module.exports = __webpack_public_path__ + "static/img/ionicons.a2c4a26.svg";


//////////////////
// WEBPACK FOOTER
// ./~/view-design/dist/styles/fonts/ionicons.svg?v=3.0.0
// module id = 560
// module chunks = 8